export default (num, words) => {
  const condition = (num % 100 > 4 && num % 100 < 20);
  const index = (num % 10 < 5) ? num % 10 : 5;
  return words[condition ? 2 : [2, 0, 1, 1, 1, 2][index]];
};
